import request from './request';

// 登录前判断机构是否可用
export function departIsUse(data, options) {
  return request('/jishi/comm/departIsUse', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 登录
export function login(data, options) {
  return request('/jishi/patient/gainSystemLogin', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 修改密码
export function updateUserRealPwd(data, options) {
  return request('/jishi/patient/updateUserRealPwd', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 获取患者列表
export function getPatientList(params, options) {
  return request('/jishi/patient/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

// 添加患者基础信息
export function insertPatientBase(data, options) {
  return request('/jishi/patient/insertPatientBase', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 更新训练信息
export function updatePatientModeByNo(data, options) {
  return request('/jishi/patient/updatePatientModeByNo', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 获取设备列表
export function gainPatientDeviceList(params, options) {
  return request('/jishi/patient/gainPatientDeviceList', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

// 绑定设备
export function dealPatientDevice(data, options) {
  return request('/jishi/patient/dealPatientDevice', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 解绑设备
export function dealPatientDeviceUnbind(data, options) {
  return request('/jishi/patient/dealPatientDeviceUnbind', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 获取每日训练时长、获取训练表格数据
export function gainPatientOneListByNo(params, options) {
  return request('/jishi/patient/gainPatientOneListByNo', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

// 删除患者
export function delPatient(data, options) {
  return request('/jishi/patient/delPatient', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}